import { render, staticRenderFns } from "./RoleEditDialog.vue?vue&type=template&id=9513ec2c&scoped=true"
import script from "./RoleEditDialog.vue?vue&type=script&lang=ts"
export * from "./RoleEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9513ec2c",
  null
  
)

export default component.exports